export class UpdatePurchaseOrderMessage {
  description: string
  setACalendarDate: string
  venderPoNumber: string
  submitted: boolean
  verified: boolean

  constructor(description: string, setACalendarDate: string, venderPoNumber: string, submitted: boolean, verified: boolean) {
    this.description = description
    this.setACalendarDate = setACalendarDate
    this.venderPoNumber = venderPoNumber
    this.submitted = submitted
    this.verified = verified
  }
}
    